import service from '@/api/doctorDrafts';
import {loading, alert, handleError} from '@/state/generators/helpers';

export const state = {
    service: service('doctor/therapy-drafts')
};

export const actions = {
    approve: function ({commit, state}, {id, data}) {
        loading(commit);

        return state.service.approve(id, data).then(response => {
            commit('REMOVE_ITEM', id);
            commit('SET_ITEM', {});
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.save_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    reject: function ({commit, state}, {id, data}) {
        loading(commit);

        return state.service.reject(id, data).then(response => {
            commit('REMOVE_ITEM', id);
            commit('SET_ITEM', {});
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.save_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    }
};
